$ = require 'jquery'
_ = require 'underscore'
log = require 'debug/log'
l = require 'lib/localize'

# The Alerts class provides an interface for displaying alerts in the upper-right-hand corner of the Trello UI
# Each alert will have
# - A message to display for the user
# - A displayType string (info, confirm, warning, error)
# - An area string. Areas do not interfere with each others' alerts.
# - Optionally, an amount of time to persist before clearing
# Setting a new alert in a given area will clear old alerts in that area.
# Calling 'hide' will hide alerts in the specified area only
# Calling 'hideAll' will hide all alerts - never call this unless you're about
# to reload the page.

module.exports = new class

  _alerts: {}

  _hide: (area) ->
    alert = @_alerts[area]
    if alert?.timeout
      clearTimeout(alert.timeout)
    delete @_alerts[area]
    $("#notification_#{area}").remove()
    @_showHideContainer()

  _show: (msg, fHtml, displayType, area, msTimeout) ->
    log('alerts', "show", msg, fHtml, displayType, area, msTimeout)
    @_hide(area)
    if msTimeout
      timeout = setTimeout (=> @hide(area)), msTimeout
    @_alerts[area] = { timeout }
    $div = $('<div>')
      .attr('id', "notification_#{area}")
      .addClass("app-alert-item mod-#{displayType}")
      .appendTo('#notification')
    if fHtml
      $div.html(msg)
      $("#notification_#{area} .js-dismiss-alert").one('click', (=> @hide(area)))
    else
      $div.text(msg)
    @_showHideContainer()

  _showHideContainer: ->
    $('#notification').toggle(!_.isEmpty(@_alerts))

  show: (key, args...) ->
    if Array.isArray(key)
      [key, data] = key
    else
      data = {}
    @showLiteralText l(['alerts', key], data), args...

  showLiteralText: (text, displayType, area, msTimeout) ->
    @_show text, false, displayType, area, msTimeout

  showHtml: (msgHtml, displayType, area, msTimeout) ->
    @_show msgHtml, true, displayType, area, msTimeout

  flash: (key, displayType, area) ->
    @show key, displayType, area, 2000

  hide: (area) ->
    log('alerts', "hide", area)
    @_hide(area)

  hideAll: ->
    @hide(area) for area of @_alerts



// WEBPACK FOOTER //
// ./app/scripts/views/lib/alerts.coffee